module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10245.8c3c1e58.jpg";